import React, { useRef, useEffect } from 'react';

import RiskMatrix from '../Charts/General/RiskMatrix';
import RiskByDepartment from '../Charts/General/RiskByDepartment';
import RiskLevelByDepartment from '../Charts/General/RiskLevelByDepartment';
import RiskLineChart from '../Charts/General/RiskLineChart';
import RiskAppetite from '../Charts/General/RiskAppetite';
import Metric from '../Charts/General/Metric';
import TopRisks from '../Charts/General/Notifications.js';
import ControlMetric from '../Charts/General/ControlMetric.js';
import IncidentTrend from '../Charts/General/IncidentMetric.js';
import ActionsMetric from '../Charts/General/ActionMetric.js';
import RiskMetric from '../Charts/General/RiskMetric.js';
import { connect } from "react-redux";
import { compose } from "redux";
import UserBlock from '../Charts/General/UserBlock.js';
import { useHistory } from 'react-router-dom';

import { getGeneralDashboardData } from "../../store/actions/dashboardActions";



const GeneralDashboard = (props) => {

    const { general_dashboard_data, getGeneralDashboardDataFN, profile } = props;
    const history = useHistory();
    useEffect(() => {
        getGeneralDashboardDataFN();
    }, []);

    //console.log("general_dashboard_data: ", general_dashboard_data);



    const handleRiskBoxClick = () => {
        history.push('/risk');
    };


    const handleActionBoxClick = () => {
        history.push('/actions');
    };

    const handleControlBoxClick = () => {
        history.push('/controls');
    };


    return (
        <div className="flex flex-col pl-8 pr-8 pt-8 pb-4 overflow-auto bg-[#F6F8FA]" style={{ maxHeight: "calc(100vh - 100px)" }}>
            {/* Grid Layout: 5 rows x 6 columns with increased gap */}
            <div className="grid grid-cols-6 gap-8 w-full">


            <div className="row-span-1 col-span-2 bg-white shadow-lg rounded-[5px] max-h-[150px] overflow-auto flex items-center justify-center">
                     <div className="w-full flex items-center justify-center p-2">
                        <UserBlock height={(window.innerHeight - 800) / 2} profile={profile} />
                    </div>
                </div>

                <div className="row-span-1 col-span-1 bg-[#FFFFFF] shadow-lg rounded-[5px] cursor-pointer max-h-[150px] overflow-hidden flex items-center justify-center p-2"
                 onClick={handleRiskBoxClick}>
                    <div className="w-full h-full flex items-center justify-center">
                         <RiskMetric height="100%" data={general_dashboard_data.quarter_risks} />
                    </div>
                </div>

                <div className="row-span-1 col-span-1 bg-[#FFFFFF] shadow-lg rounded-[5px] cursor-pointer max-h-[150px] overflow-hidden flex items-center justify-center p-2"
                onClick={handleControlBoxClick}>
                    <div className="w-full h-full flex items-center justify-center">
                        <ControlMetric height="100%" data={general_dashboard_data.type_controls} />
                    </div>
                </div>

                <div className="row-span-1 col-span-1 bg-[#FFFFFF] shadow-lg rounded-[5px] cursor-pointer max-h-[150px] overflow-hidden flex items-center justify-center p-2"
                    onClick={handleActionBoxClick}>
                    <div className="w-full h-full flex items-center justify-center">
                        <ActionsMetric
                            height="100%"
                            data={general_dashboard_data.overdue_actions}
                        />
                    </div>
                </div>

                <div className="row-span-1 col-span-1 bg-[#FFFFFF] shadow-lg rounded-[5px] max-h-[150px] overflow-hidden flex items-center justify-center p-2">
                    <div className="w-full h-full flex items-center justify-center">
                        <IncidentTrend height="100%" data={general_dashboard_data.incident_details}/>
                    </div>
                </div>


                
                {/* Risk Matrix - Spans 2 rows, 2 columns */}
                <div className="row-span-2 col-span-2 bg-[#FFFFFF] shadow-lg rounded-[5px]   max-h-[400px] overflow-auto ">
                    <div className="bg-[#ffffff] text-black px-3 py-1 flex-none flex rounded-tl-[5px] rounded-tr-[5px]">
                        <div className="flex justify-center items-center gap-1 flex-nowrap overflow-hidden">
                            <h2 className="text-base text-sm font-normal items-center text-ellipsis whitespace-nowrap mt-2">
                                General Risk Level
                            </h2>
                        </div>
                    </div>
                    <div className="contents p-2">
                        <RiskMatrix height={(window.innerHeight - 450) / 2} points={general_dashboard_data.points} />
                    </div>
                </div>

                {/* Risk By Department - Spans 1 row, 2 columns */}
                <div className="row-span-2 col-span-2 bg-[#FFFFFF] shadow-lg rounded-[5px]   max-h-[400px] overflow-auto ">
                    <div className="bg-[#ffffff] text-black px-3 py-1 flex-none flex rounded-tl-[5px] rounded-tr-[5px]">
                        <div className="flex justify-center items-center gap-1 flex-nowrap overflow-hidden">
                            <h2 className="text-base text-sm font-normal items-center text-ellipsis whitespace-nowrap mt-2">
                                Number of Risks by Department
                            </h2>
                        </div>
                    </div>
                    <div className="contents p-2">
                        <RiskByDepartment height={(window.innerHeight - 475) / 2} risks_by_department={general_dashboard_data.risks_by_department} />
                    </div>
                </div>

                {/* Risk Level By Department - Spans 1 row, 2 columns */}
                <div className="row-span-2 col-span-2 bg-[#FFFFFF] shadow-lg rounded-[5px]   max-h-[400px] overflow-auto ">
                    <div className="bg-[#ffffff] text-black px-3 py-1 flex-none flex rounded-tl-[5px] rounded-tr-[5px]">
                        <div className="flex justify-center items-center gap-1 flex-nowrap overflow-hidden">
                            <h2 className="text-base text-sm font-normal items-center text-ellipsis whitespace-nowrap mt-2">
                                Risk Level by Department
                            </h2>
                        </div>
                    </div>
                    <div className="contents p-2">
                        <RiskLevelByDepartment height={(window.innerHeight - 500) / 2} data={general_dashboard_data.risk_level_by_department} />
                    </div>
                </div>

                {/* Risk Line Chart - Spans 3 rows, 4 columns */}
                <div className="row-span-2 col-span-3 bg-[#FFFFFF] shadow-lg rounded-[5px]    max-h-[400px] overflow-auto">
                    <div className="bg-[#ffffff] text-black px-3 py-1 flex-none flex rounded-tl-[5px] rounded-tr-[5px]">
                        <div className="flex justify-center items-center gap-1 flex-nowrap overflow-hidden">
                            <h2 className="text-base text-sm font-normal items-center text-ellipsis whitespace-nowrap mt-1">
                                General Risk Level Time Series
                            </h2>
                        </div>
                    </div>
                    <div className="contents p-2">
                        <RiskLineChart height={(window.innerHeight - 475) / 2} data={general_dashboard_data.risk_assessment_history} />
                    </div>
                </div>

                <div className="row-span-2 col-span-1 bg-[#FFFFFF] shadow-lg rounded-[5px]  max-h-[400px] overflow-auto ">
                    <div className="bg-[#ffffff] text-black px-3 py-1 flex-none flex rounded-tl-[5px] rounded-tr-[5px]">
                        <div className="flex justify-center items-center gap-1 flex-nowrap overflow-hidden">
                            <h2 className="text-base text-sm font-normal items-center text-ellipsis whitespace-nowrap mt-1">
                                Risk Appetite
                            </h2>
                        </div>
                    </div>
                     <div className="contents p-2">
                        <RiskAppetite height={(window.innerHeight - 475) / 2} risk_appetite={general_dashboard_data.risk_appetite} />
                    </div>
                </div>

                {/* Risk Appetite - Spans 2 rows, 2 columns */}
                <div className="row-span-2 col-span-2 bg-[#FFFFFF] shadow-lg rounded-[5px] max-h-[400px] overflow-auto ">
                    <div className="bg-[#ffffff] text-black px-3 py-1 flex-none flex rounded-tl-[5px] rounded-tr-[5px]">
                        <div className="flex justify-center items-center gap-1 flex-nowrap overflow-hidden">
                            <h2 className="text-base text-sm font-normal items-center text-ellipsis whitespace-nowrap mt-1">
                                Top 10 Risks
                            </h2>
                        </div>
                    </div>

                    <div className="contents p-2">
                        <TopRisks height={(window.innerHeight - 475) / 2} risks = {general_dashboard_data.top5Risk}/>
                    </div>
                   
                </div>
            </div>
        </div>
    );
};



const mapStateToProps = (state) => {
    
    return {
        general_dashboard_data: state.dashboard.general_dashboard_data,
        profile: state.profile.profile
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        getGeneralDashboardDataFN: () => dispatch(getGeneralDashboardData()),
    };
};


export default compose(connect(mapStateToProps, mapDispatchToProps))(GeneralDashboard);